import { useState } from 'react';
import { URG, CCOL, C } from '../constants';

export const UBadge = ({ u }) => {
  const d = URG[u];
  return (
    <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.1em', padding: '2px 6px', borderRadius: 4, background: d.bg, color: d.color, border: `1px solid ${d.color}44`, textTransform: 'uppercase' }}>
      {d.label}
    </span>
  );
};

export const CBadge = ({ code }) => {
  const c = CCOL[code] || '#AAA';
  return (
    <span style={{ fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 4, background: c + '22', color: c, border: `1px solid ${c}44` }}>
      {code}
    </span>
  );
};

export const SLabel = ({ children, color = '#4A9EFF', mb = 8 }) => (
  <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.12em', textTransform: 'uppercase', color, marginBottom: mb, opacity: 0.9 }}>
    {children}
  </div>
);

export const Card = ({ children, s = {} }) => (
  <div style={{ background: C.bg2, borderRadius: 12, padding: '12px 14px', marginBottom: 12, border: `1px solid ${C.bd}`, ...s }}>
    {children}
  </div>
);

export const IFld = ({ label, value, onChange, rows = 1 }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.12em', textTransform: 'uppercase', color: C.dim, marginBottom: 4 }}>{label}</div>
    {rows > 1
      ? <textarea value={value} onChange={e => onChange(e.target.value)} rows={rows}
          style={{ width: '100%', background: C.bg3, border: `1px solid ${C.bd}`, borderRadius: 8, padding: '8px 10px', color: C.tx, fontSize: 13, lineHeight: 1.5 }} />
      : <input value={value} onChange={e => onChange(e.target.value)}
          style={{ width: '100%', background: C.bg3, border: `1px solid ${C.bd}`, borderRadius: 8, padding: '8px 10px', color: C.tx, fontSize: 13 }} />
    }
  </div>
);

export const ICell = ({ value, onChange, ph = '', mono = false }) => {
  const [f, setF] = useState(false);
  return (
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={ph}
      onFocus={() => setF(true)} onBlur={() => setF(false)}
      style={{ width: '100%', background: 'transparent', border: 'none', borderBottom: `1px solid ${f ? '#4A9EFF' : C.bd}`, color: C.tx, fontSize: 12, padding: '3px 0', fontFamily: mono ? "'IBM Plex Mono',monospace" : 'inherit', outline: 'none' }} />
  );
};

export const WBtn = ({ onClick, children, bg = '#1A3D6A', color = '#7DC4FF', bdr, mb = 0 }) => (
  <button onClick={onClick}
    style={{ width: '100%', padding: '11px 0', borderRadius: 10, cursor: 'pointer', background: bg, color, border: bdr || 'none', fontSize: 13, fontWeight: 600, marginBottom: mb }}>
    {children}
  </button>
);

export const AppShell = ({ children }) => (
  <>
    <div style={{ position: 'fixed', inset: 0, display: 'flex', justifyContent: 'center', background: C.bg0, WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)' }}>
      <div className="mobile-shell" style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', maxWidth: 480, height: '100%', minHeight: '-webkit-fill-available', overflow: 'hidden', WebkitBackfaceVisibility: 'hidden', backfaceVisibility: 'hidden', WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)' }}>
        {children}
      </div>
    </div>
  </>
);

export const TopBar = ({ left, title, right }) => (
  <div className="topbar" style={{ display: 'flex', alignItems: 'center', gap: 8, background: C.bg0, borderBottom: `1px solid ${C.bd}`, flexShrink: 0 }}>
    <div style={{ flexShrink: 0 }}>{left}</div>
    <div style={{ flex: 1, textAlign: 'center', fontSize: 15, fontWeight: 700, color: '#E8F4FF', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</div>
    <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5 }}>{right}</div>
  </div>
);

export const BackBtn = ({ onClick }) => (
  <button onClick={onClick} style={{ background: 'none', border: 'none', color: '#4A9EFF', fontSize: 13, cursor: 'pointer', fontWeight: 600 }}>← Back</button>
);

export const SyncBar = ({ status, meta, onRefresh, shiftCode }) => {
  const map = {
    loading: { bg: C.bg3,     color: C.dim,     icon: '⏳', text: 'Loading…' },
    synced:  { bg: '#081A0C', color: '#30D158', icon: '✓',  text: (shiftCode ? shiftCode + ' · ' : '') + (meta ? `Saved · ${new Date(meta.saved).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} · ${meta.count} pts` : 'Saved') },
    saving:  { bg: '#1A1500', color: '#FF9500', icon: '↑',  text: 'Saving…' },
    error:   { bg: '#1A0808', color: '#FF4545', icon: '!',  text: 'Save error — tap to retry' },
    fresh:   { bg: '#080F1A', color: '#64D2FF', icon: '✦',  text: 'Demo data loaded' },
  };
  const s = map[status] || map.loading;
  return (
    <div onClick={status === 'error' ? onRefresh : undefined}
      style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '5px 14px', background: s.bg, flexShrink: 0, cursor: status === 'error' ? 'pointer' : 'default' }}>
      <span style={{ fontSize: 10, color: s.color }}>{s.icon}</span>
      <span style={{ fontSize: 10, color: s.color, fontWeight: 600 }}>{s.text}</span>
      {status === 'synced' && (
        <button onClick={e => { e.stopPropagation(); onRefresh(); }}
          style={{ marginLeft: 'auto', background: 'none', border: 'none', color: C.dim, fontSize: 10, cursor: 'pointer' }}>↻ Refresh</button>
      )}
    </div>
  );
};
